let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1TK6P")).then(() => parcelRequire('kdo1N'));